import * as net from '~/lib/net';
import { getToken } from '~/apps/shared/services/token';
import { TransactionEndpoints } from './endpoints';
import { Transaction, TransactionFilter } from '../models';
import { TransactionSchema, TransactionListSchema } from './schemas';
import { defaultTablePageSize } from '~/common/components/consts';

export async function getTransactionById(transactionId: string): Promise<Transaction> {
  const data = await net.apiGet(TransactionEndpoints.getTransactionById(transactionId), getToken());
  return TransactionSchema.load(data);
}

export async function getOrgTransactions(orgId: string, filter: TransactionFilter=null, offset=0, limit=defaultTablePageSize): Promise<Transaction[]> {
  const data = await net.apiGet(TransactionEndpoints.getTransactions(orgId, filter, offset, limit), getToken());
  // TODO: We could use the returned count too
  return TransactionListSchema.load(data);
}

export async const exportTransactions = async (orgId: string, startDate: Date, endDate: Date): Promise<Blob> => {
  const resp = await net.rawRequest(
    'GET',
    TransactionEndpoints.csvExport(orgId, startDate, endDate),
    getToken());

  return resp.blob();
};
